import svgPaths from "../../imports/svg-e37hx0wew5";
import footerSvgPaths from "../../imports/svg-5m69q41oxb";
import imgImage1946 from "figma:asset/17ba3ad644045ad9203e38251e21010bc7fb118c.png";
import { useTheme } from "./theme-provider";
import { useState, useRef, useEffect } from "react";

function Wrapper3({ children }: React.PropsWithChildren<{}>) {
  return (
    <div className="relative shrink-0 size-[28px]">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 28 28">
        {children}
      </svg>
    </div>
  );
}

function Wrapper2({ children }: React.PropsWithChildren<{}>) {
  return (
    <div className="relative shrink-0 size-[16px]">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 16 16">
        {children}
      </svg>
    </div>
  );
}

function Wrapper4({ children }: React.PropsWithChildren<{}>) {
  return (
    <div className="absolute inset-[-100%]">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 3 3">
        {children}
      </svg>
    </div>
  );
}

function Tiktok({ children }: React.PropsWithChildren<{}>) {
  return <Wrapper3><g id="tiktok">{children}</g></Wrapper3>;
}

function X({ children }: React.PropsWithChildren<{}>) {
  return <Wrapper3><g id="X">{children}</g></Wrapper3>;
}

function Frame({ children }: React.PropsWithChildren<{}>) {
  return <Wrapper3><g id="Frame">{children}</g></Wrapper3>;
}

function Youtube({ children }: React.PropsWithChildren<{}>) {
  return <Wrapper3><g id="youtube">{children}</g></Wrapper3>;
}

function Frame36235854Helper1() {
  return (
    <Wrapper4>
      <path d="M1 2L2 1" stroke="var(--stroke-0, #3B0E27)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    </Wrapper4>
  );
}

function Frame36235854Vector1({ additionalClassNames = "" }: { additionalClassNames?: string }) {
  return (
    <div className={`absolute bottom-1/2 top-1/2 ${additionalClassNames}`}>
      <div className="absolute inset-[-1px_-50%]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 4 2">
          <path d="M1 1H3" stroke="var(--stroke-0, #3B0E27)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </svg>
      </div>
    </div>
  );
}

function Frame36235854Helper() {
  return (
    <Wrapper4>
      <path d="M1 1L2 2" stroke="var(--stroke-0, #3B0E27)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    </Wrapper4>
  );
}

function Frame36235854Vector({ additionalClassNames = "" }: { additionalClassNames?: string }) {
  return (
    <div className={`absolute left-1/2 right-1/2 ${additionalClassNames}`}>
      <div className="absolute inset-[-50%_-1px]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 2 4">
          <path d="M1 1V3" stroke="var(--stroke-0, #3B0E27)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </svg>
      </div>
    </div>
  );
}

function AvatarImage() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute inset-0 size-full">
        <g clipPath="url(#clip0_27930_1960)">
          <rect width="36" height="36" rx="18" fill="var(--brand-text)"/>
          <mask id="mask0_27930_1960" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="-6" y="1" width="48" height="43">
            <path d="M-5.72559 1.72486L41.7266 1.72485L41.7266 3.99341L-5.72559 3.99341L-5.72559 1.72486ZM-5.72559 4.1858L41.7266 4.18579L41.7266 6.32935L-5.72559 6.32935L-5.72559 4.1858ZM-5.72559 6.64576L41.7266 6.64575L41.7266 8.66528L-5.72559 8.66529L-5.72559 6.64576ZM-5.72559 9.10669L41.7266 9.10669L41.7266 11.0022L-5.72559 11.0022L-5.72559 9.10669ZM-5.72559 11.5676L41.7266 11.5676L41.7266 13.3381L-5.72559 13.3381L-5.72559 11.5676ZM-5.72559 14.0276L41.7266 14.0276L41.7266 15.6741L-5.72559 15.6741L-5.72559 14.0276ZM-5.72559 16.4885L41.7266 16.4885L41.7266 18.011L-5.72559 18.011L-5.72559 16.4885ZM-5.72559 18.9495L41.7266 18.9495L41.7266 20.3469L-5.72559 20.3469L-5.72559 18.9495ZM-5.72559 21.4104L41.7266 21.4104L41.7266 22.6829L-5.72559 22.6829L-5.72559 21.4104ZM-5.72559 23.8704L41.7266 23.8704L41.7266 25.0188L-5.72559 25.0188L-5.72559 23.8704ZM-5.72559 26.3313L41.7266 26.3313L41.7266 27.3547L-5.72559 27.3547L-5.72559 26.3313ZM-5.72559 28.7932L41.7266 28.7932L41.7266 29.6926L-5.72559 29.6926L-5.72559 28.7932ZM-5.72559 31.2542L41.7266 31.2542L41.7266 32.0286L-5.72559 32.0286L-5.72559 31.2542ZM-5.72559 33.7151L41.7266 33.7151L41.7266 34.3645L-5.72559 34.3645L-5.72559 33.7151ZM-5.72559 36.1751L41.7266 36.175L41.7266 36.7004L-5.72559 36.7004L-5.72559 36.1751ZM-5.72559 38.637L41.7266 38.637L41.7266 39.0364L-5.72559 39.0364L-5.72559 38.637ZM-5.72559 41.0969L41.7266 41.0969L41.7266 41.3733L-5.72559 41.3733L-5.72559 41.0969ZM-5.72559 43.7092L-5.72559 43.5579L41.7266 43.5579L41.7266 43.7092L-5.72559 43.7092Z" fill="white"/>
          </mask>
          <g mask="url(#mask0_27930_1960)">
            <path opacity="0.7" d="M25.7652 27.4544C23.7753 24.0961 19.41 24.5773 19.41 24.5773H15.6786C15.6786 24.5773 12.2031 24.4513 10.2107 27.3105C10.1802 27.3627 10.1458 27.4098 10.1114 27.462C10.0821 27.4875 10.0554 27.5091 10.0274 27.532C9.95227 27.6492 9.87843 27.7752 9.80332 27.9127C9.81732 27.9178 9.83005 27.9229 9.84024 27.9254C9.67983 28.2233 9.52452 28.5543 9.37302 28.912C9.35902 28.9095 9.34629 28.9069 9.33228 28.9018C7.92299 32.2168 6.64991 38.8493 6.65627 39.4514H6.71356C6.79833 44.2736 29.3489 43.2812 29.3489 39.1179C29.3501 39.1179 28.1242 30.4384 25.7652 27.4544ZM9.88352 14.4147C9.88352 18.6915 13.3507 22.1586 17.6277 22.1586C21.9046 22.1586 25.3718 18.6915 25.3718 14.4147C25.3718 10.1379 21.9046 6.6709 17.6277 6.6709C13.3507 6.6709 9.88352 10.1379 9.88352 14.4147Z" fill="white"/>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_27930_1960">
            <rect width="36" height="36" rx="18" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export function Nav({ variant = "signin", onEventsClick, onPlaygroundClick, onBenchmarkClick, onShareBoardClick, onCompetitionsClick, onCompetitionDetailClick, activePage }: { variant?: "signin" | "profile"; onAvatarClick?: () => void; onEventsClick?: () => void; onResearchGrantsClick?: () => void; onPlaygroundClick?: () => void; onBenchmarkClick?: () => void; onShareBoardClick?: () => void; onCompetitionsClick?: () => void; onCompetitionDetailClick?: () => void; activePage?: string }) {
  const [showCompDropdown, setShowCompDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setShowCompDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="h-[90px] w-full relative sticky top-0 z-50" style={{ backgroundColor: 'var(--brand-bg)' }}>
      <div className="flex flex-row items-center size-full">
        <div className="content-stretch flex items-center justify-between px-[24px] relative size-full">
          {/* Logo */}
          <div className="flex-[1_0_0] min-h-px min-w-px relative">
            <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex flex-col items-start relative w-full">
              <div className="h-[42px] relative shrink-0 w-[154.636px]">
                <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 154.636 42">
                  <path d={svgPaths.p8989200} fill="url(#paint0_linear_nav)" />
                  <defs>
                    <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_nav" x1="77.3179" x2="77.3179" y1="42" y2="0">
                      <stop stopColor="var(--brand-logo-start)" />
                      <stop offset="1" stopColor="var(--brand-logo-end)" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
          {/* Nav links */}
          <div className="relative shrink-0 hidden md:block">
            <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex gap-[48px] items-center relative">
              {/* Collaborations */}
              <a
                href="https://form.typeform.com/to/mLcUZuFH"
                target="_blank"
                rel="noopener noreferrer"
                className="cursor-pointer no-underline"
              >
                <p className="font-['Helvetica_Neue:Regular',sans-serif] leading-[20px] not-italic relative shrink-0 text-[16px] text-center opacity-60" style={{ color: 'var(--brand-text)' }}>Collaborations</p>
              </a>
              {/* Competitions dropdown */}
              <div className="relative" ref={dropdownRef}>
                <button
                  onClick={() => setShowCompDropdown(!showCompDropdown)}
                  className="cursor-pointer bg-transparent border-none p-0 flex items-center gap-[4px]"
                >
                  <p className={`font-['Helvetica_Neue:Regular',sans-serif] leading-[20px] not-italic relative shrink-0 text-[16px] text-center ${activePage === 'competitions' || activePage === 'competition-detail' || activePage === 'share-board' ? 'opacity-100' : 'opacity-60'}`} style={{ color: 'var(--brand-text)' }}>Competitions</p>
                  <span className="px-[3px] shrink-0 flex items-center" style={{ backgroundColor: 'var(--brand-primary-btn-bg)', height: '16px' }}>
                    <span className="font-['Helvetica_Neue:Regular',sans-serif] text-[11px] text-center" style={{ color: 'var(--brand-primary-btn-text)' }}>NEW</span>
                  </span>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" className="shrink-0">
                    <path d="M3.5 6.25L7 9.75L10.5 6.25" stroke="var(--stroke-0, #3B0E27)" strokeLinecap="round" strokeLinejoin="round" strokeOpacity="0.3" strokeWidth="1.16667" />
                  </svg>
                </button>
                {/* Dropdown menu */}
                {showCompDropdown && (
                  <div
                    className="absolute top-[calc(100%+8px)] left-0 min-w-[200px] py-[8px] z-50 shadow-lg"
                    style={{ backgroundColor: 'var(--brand-bg)', border: '1px solid var(--brand-border)' }}
                  >
                    <button
                      onClick={() => { setShowCompDropdown(false); onCompetitionsClick?.(); }}
                      className="w-full bg-transparent border-none cursor-pointer text-left px-[16px] py-[12px] transition-colors hover:bg-[rgba(59,14,39,0.03)]"
                    >
                      <p className="font-['Helvetica_Neue:Regular',sans-serif] text-[16px] m-0 whitespace-nowrap" style={{ color: 'var(--brand-text)' }}>All Competitions</p>
                    </button>
                    <button
                      onClick={() => { setShowCompDropdown(false); onCompetitionDetailClick?.(); }}
                      className="w-full bg-transparent border-none cursor-pointer text-left px-[16px] py-[12px] transition-colors hover:bg-[rgba(59,14,39,0.03)]"
                    >
                      <p className="font-['Helvetica_Neue:Regular',sans-serif] text-[16px] m-0 whitespace-nowrap" style={{ color: 'var(--brand-text)' }}>Mathematics Distillation</p>
                    </button>
                    <button
                      onClick={() => { setShowCompDropdown(false); onPlaygroundClick?.(); }}
                      className="w-full bg-transparent border-none cursor-pointer text-left px-[16px] py-[12px] transition-colors hover:bg-[rgba(59,14,39,0.03)]"
                    >
                      <p className="font-['Helvetica_Neue:Regular',sans-serif] text-[16px] m-0 whitespace-nowrap" style={{ color: 'var(--brand-text)' }}>Playground</p>
                    </button>
                    <button
                      onClick={() => { setShowCompDropdown(false); onBenchmarkClick?.(); }}
                      className="w-full bg-transparent border-none cursor-pointer text-left px-[16px] py-[12px] transition-colors hover:bg-[rgba(59,14,39,0.03)]"
                    >
                      <p className="font-['Helvetica_Neue:Regular',sans-serif] text-[16px] m-0 whitespace-nowrap" style={{ color: 'var(--brand-text)' }}>Benchmarks</p>
                    </button>
                    <button
                      onClick={() => { setShowCompDropdown(false); onShareBoardClick?.(); }}
                      className="w-full bg-transparent border-none cursor-pointer text-left px-[16px] py-[12px] transition-colors hover:bg-[rgba(59,14,39,0.03)]"
                    >
                      <p className="font-['Helvetica_Neue:Regular',sans-serif] text-[16px] m-0 whitespace-nowrap" style={{ color: 'var(--brand-text)' }}>Share Board</p>
                    </button>
                  </div>
                )}
              </div>
              {/* Events */}
              <a
                href="https://sair.foundation/event/ai-for-science-kickoff-2026/"
                target="_blank"
                rel="noopener noreferrer"
                className="cursor-pointer no-underline"
              >
                <p className="font-['Helvetica_Neue:Regular',sans-serif] leading-[20px] not-italic relative shrink-0 text-[16px] text-center opacity-60" style={{ color: 'var(--brand-text)' }}>Events</p>
              </a>
              {/* Blog */}
              <a
                href="https://blog.sair.foundation/"
                target="_blank"
                rel="noopener noreferrer"
                className="cursor-pointer no-underline"
              >
                <p className="font-['Helvetica_Neue:Regular',sans-serif] leading-[20px] not-italic relative shrink-0 text-[16px] text-center opacity-60" style={{ color: 'var(--brand-text)' }}>Blog</p>
              </a>
            </div>
          </div>
          {/* Right side */}
          <div className="flex-[1_0_0] h-[36px] min-h-px min-w-px relative hidden md:block">
            <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-center justify-end relative size-full">
              {variant === "profile" ? (
                <div className="relative rounded-[80px] shrink-0 size-[36px]" style={{ backgroundColor: 'var(--brand-avatar-bg)' }}>
                  <div className="bg-clip-padding border-0 border-[transparent] border-solid relative size-full">
                    <div className="-translate-x-1/2 -translate-y-1/2 absolute left-1/2 size-[20px] top-1/2">
                      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
                        <path d={svgPaths.p36365e00} stroke="var(--stroke-0, #3B0E27)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66667" />
                        <path d={svgPaths.p483da00} stroke="var(--stroke-0, #3B0E27)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66667" />
                      </svg>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex gap-[16px] items-center">
                  <div className="relative shrink-0 w-[90px]">
                    <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex items-center justify-center px-[20px] py-[10px] relative w-full">
                      <p className="font-['Helvetica_Neue:Regular',sans-serif] text-[16px]" style={{ color: 'var(--brand-text)' }}>Sign In</p>
                    </div>
                  </div>
                  <div className="h-[36px] relative shrink-0" style={{ backgroundColor: 'var(--brand-primary-btn-bg)' }}>
                    <div className="bg-clip-padding border-0 border-[transparent] border-solid content-stretch flex h-full items-center justify-center px-[20px] py-[10px] relative">
                      <p className="font-['Helvetica_Neue:Regular',sans-serif] text-[16px] text-center" style={{ color: 'var(--brand-primary-btn-text)' }}>Register</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Avatar in top-right for profile variant */}
      {variant === "profile" && (
        <div
          className="absolute right-[24px] top-[27px] rounded-full size-[36px] overflow-hidden bg-transparent hidden md:block"
        >
          <div className="absolute h-[39.3px] left-[-1.35px] top-[-2.1px] w-[38.7px]">
            <AvatarImage />
          </div>
        </div>
      )}
      {/* Mobile menu button */}
      {variant === "profile" && (
        <div className="absolute right-[24px] top-[27px] md:hidden">
          <div className="relative rounded-[80px] shrink-0 size-[36px] flex items-center justify-center" style={{ backgroundColor: 'var(--brand-avatar-bg)' }}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M3 5H17M3 10H17M3 15H17" stroke="var(--stroke-0, #3B0E27)" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </div>
        </div>
      )}
    </div>
  );
}

export function Footer() {
  const { mode, setMode } = useTheme();

  return (
    <div className="content-stretch flex flex-col items-start px-[24px] py-[40px] md:py-[60px] w-full relative" style={{ backgroundColor: 'var(--brand-bg)' }}>
      <div aria-hidden="true" className="absolute inset-x-0 top-0 pointer-events-none" style={{ borderTop: '0.571px solid var(--brand-border-line)' }} />
      <div className="content-stretch flex flex-col items-center relative shrink-0 w-full">
        <div className="content-stretch flex flex-col md:flex-row items-center justify-between gap-[20px] md:gap-0 relative shrink-0 w-full">
          {/* Theme toggle - left */}
          <div className="content-stretch flex gap-[24px] items-center relative order-1 md:order-none md:flex-[1_0_0] md:min-h-px md:min-w-px">
            {/* System / Monitor */}
            <button
              onClick={() => setMode("system")}
              className="bg-transparent border-none cursor-pointer p-0"
              title="Follow system"
            >
              <div className="overflow-clip relative shrink-0 size-[24px]" style={{ opacity: mode === 'system' ? 1 : 0.54 }}>
                <div className="absolute inset-[16.67%_8.33%_29.17%_8.33%]">
                  <div className="absolute inset-[-7.69%_-5%]">
                    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 22 15">
                      <path d={svgPaths.p209ef9c0} stroke="var(--stroke-0, #3B0E27)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                    </svg>
                  </div>
                </div>
                <div className="absolute inset-[87.5%_33.33%_12.5%_33.33%]">
                  <div className="absolute inset-[-1px_-12.5%]">
                    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 10 2">
                      <path d="M1 1H9" stroke="var(--stroke-0, #3B0E27)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                    </svg>
                  </div>
                </div>
                <div className="absolute bottom-[12.5%] left-1/2 right-1/2 top-3/4">
                  <div className="absolute inset-[-33.33%_-1px]">
                    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 2 5">
                      <path d="M1 1V4" stroke="var(--stroke-0, #3B0E27)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                    </svg>
                  </div>
                </div>
              </div>
            </button>
            {/* Light / Sun */}
            <button
              onClick={() => setMode("light")}
              className="bg-transparent border-none cursor-pointer p-0"
              title="Light mode"
            >
              <div className="overflow-clip relative shrink-0 size-[24px]" style={{ opacity: mode === 'light' ? 1 : 0.54 }}>
                <div className="absolute inset-[29.17%]">
                  <div className="absolute inset-[-10%]">
                    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 12 12">
                      <path d={svgPaths.p3e7757b0} stroke="var(--stroke-0, #3B0E27)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                    </svg>
                  </div>
                </div>
                <Frame36235854Vector additionalClassNames="bottom-[83.33%] top-[8.33%]" />
                <Frame36235854Vector additionalClassNames="bottom-[8.33%] top-[83.33%]" />
                <div className="absolute bottom-3/4 left-[20.83%] right-3/4 top-[20.83%]"><Frame36235854Helper /></div>
                <div className="absolute bottom-[20.83%] left-3/4 right-[20.83%] top-3/4"><Frame36235854Helper /></div>
                <Frame36235854Vector1 additionalClassNames="left-[8.33%] right-[83.33%]" />
                <Frame36235854Vector1 additionalClassNames="left-[83.33%] right-[8.33%]" />
                <div className="absolute bottom-[20.83%] left-[20.83%] right-3/4 top-3/4"><Frame36235854Helper1 /></div>
                <div className="absolute bottom-3/4 left-3/4 right-[20.83%] top-[20.83%]"><Frame36235854Helper1 /></div>
              </div>
            </button>
            {/* Dark / Moon */}
            <button
              onClick={() => setMode("dark")}
              className="bg-transparent border-none cursor-pointer p-0"
              title="Dark mode"
            >
              <div className="relative shrink-0 size-[24px]" style={{ opacity: mode === 'dark' ? 1 : 0.54 }}>
                <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
                  <g id="Weather / Moon">
                    <path d={footerSvgPaths.p3e7e2d00} stroke="var(--stroke-0, #3B0E27)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                  </g>
                </svg>
              </div>
            </button>
          </div>
          <p className="font-['Helvetica_Neue:Regular',sans-serif] leading-[20px] not-italic opacity-60 relative text-[14px] text-center whitespace-pre-wrap order-3 md:order-none md:flex-[1_0_0] md:min-h-px md:min-w-px" style={{ color: 'var(--brand-text-alt)' }}>{"\u00A9 2026 SAIRiD. All rights reserved."}</p>
          <div className="content-stretch flex gap-[20px] items-center justify-center md:justify-end relative order-2 md:order-none md:flex-[1_0_0] md:min-h-px md:min-w-px">
            <Youtube><path d={svgPaths.pb30de00} fill="var(--fill-0, #340825)" /></Youtube>
            <X><path d={svgPaths.p9463580} fill="var(--fill-0, #340825)" /></X>
            <Frame><path d={svgPaths.p5282c00} fill="var(--fill-0, #340825)" /></Frame>
            <Tiktok>
              <path d={svgPaths.p79088f0} fill="var(--fill-0, #340825)" opacity="0.5" />
              <path d={svgPaths.p2d24f600} fill="var(--fill-0, #340825)" />
              <path d={svgPaths.p1ed56600} fill="var(--fill-0, #340825)" />
              <path d={svgPaths.p1add27f0} fill="var(--fill-0, #340825)" />
              <path d={svgPaths.p7eb3e00} fill="var(--fill-0, #340825)" opacity="0.5" />
            </Tiktok>
            <Wrapper3>
              <g id="instagram">
                <path d={svgPaths.p1decec00} fill="var(--fill-0, #340825)" />
                <path d={svgPaths.pa37b580} fill="var(--fill-0, white)" />
                <path clipRule="evenodd" d={svgPaths.pa2c2e70} fill="var(--fill-0, white)" fillRule="evenodd" />
                <path clipRule="evenodd" d={svgPaths.p2965f00} fill="var(--fill-0, white)" fillRule="evenodd" />
              </g>
            </Wrapper3>
          </div>
        </div>
      </div>
    </div>
  );
}